import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchAdminEmployers,
  updateEmployerStatus,
  toggleChecklistItem,
  type AdminEmployerProfile,
  type EmployerFilters,
  type EmployerVerificationStatus,
} from '../api/adminEmployers';

export function useAdminEmployers(filters: EmployerFilters) {
  return useQuery<AdminEmployerProfile[]>({
    queryKey: ['admin-employers', filters],
    queryFn: () => fetchAdminEmployers(filters),
    staleTime: 1000 * 30,
  });
}

export function useEmployerStatusAction(filters: EmployerFilters) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status, note }: { id: string; status: EmployerVerificationStatus; note?: string }) =>
      updateEmployerStatus(id, status, note),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-employers', filters] });
    },
  });
}

export function useChecklistAction(filters: EmployerFilters) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, checklistId, completed }: { id: string; checklistId: string; completed: boolean }) =>
      toggleChecklistItem(id, checklistId, completed),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-employers', filters] });
    },
  });
}
